(function () {
  angular.module('lif.services').factory('formService', formService);
  formService.$inject = ['$http', '$q', 'Upload', 'constants'];

  function formService($http, $q, Upload, constants) {
    var _formService = {};

    _formService.uploadFiles = function (files, url, folderId) {
      var deferred = $q.defer();

      if (files && files.length) {
        var successCounter = 0;
        var results = [];

        for (var i = 0; i < files.length; i++) {
          var file = files[i];
          Upload.upload({
            url: '/' + url,
            fields: {
              folder: folderId
            },
            file: file
          }).progress(function (evt) {
            var progress = parseInt(100.0 * evt.loaded / evt.total);
          }).then(function (data, status, headers, config) {
            successCounter++;
            results.push(data.data);

            if (successCounter === files.length) {
              deferred.resolve(results);
            }
          }, function () {
            deferred.reject();
          });
        }

        return deferred.promise;
      } else {
        deferred.reject('No files specified');
      }
    };

    _formService.uploadMeetingFile = function (meetingContentGuid, file, fileCategories) {
      var deferred = $q.defer();
      Upload.upload({
        url: '/api/meetingfile/' + meetingContentGuid,
        file: file,
        fields: {
          fileCategories: fileCategories
        }
      }).then(function (result) {
        deferred.resolve(result);
      }, function (result) {
        deferred.reject(result);
      });
      return deferred.promise;
    };

    _formService.deleteMeetingFile = function (fileContentGuid) {
      var deferred = $q.defer();
      $http.delete('/api/meetingfile/' + fileContentGuid).then(function (result) {
        deferred.resolve(result);
      }, function () {
        deferred.reject();
      });
      return deferred.promise;
    };

    _formService.createFolder = function (folderName, baseFolderId, url) {
      var deferred = $q.defer();
      $http.post('/' + url, {
        foldername: folderName,
        basefolderid: baseFolderId.toString()
      }).then(function (result) {
        deferred.resolve(result.data);
      }, function () {
        deferred.reject();
      });
      return deferred.promise;
    };

    _formService.moveFolder = function (folderId, destinationId, url) {
      var deferred = $q.defer();
      $http({
        url: '/' + url,
        method: 'PATCH',
        data: {
          folderReference: folderId.toString(),
          destinationFolderReference: destinationId.toString()
        }
      }).then(function (result) {
        deferred.resolve(result);
      }, function () {
        deferred.reject();
      });
      return deferred.promise;
    };

    _formService.moveFile = function (fileId, destinationId, url) {
      var deferred = $q.defer();
      $http({
        url: '/' + url,
        method: 'PATCH',
        data: {
          fileContentReferenceId: fileId.toString(),
          destinationFolderReferenceId: destinationId.toString()
        }
      }).then(function (result) {
        deferred.resolve(result);
      }, function () {
        deferred.reject();
      });
      return deferred.promise;
    };

    _formService.moveFolder = function (folderId, destinationId, url) {
      var deferred = $q.defer();
      $http({
        url: '/' + url,
        method: 'PATCH',
        data: {
          folderReference: folderId,
          destinationFolderReference: destinationId
        }
      }).then(function (result) {
        deferred.resolve(result);
      }, function () {
        deferred.reject();
      });
      return deferred.promise;
    };

    _formService.changeFolderName = function (baseFolderId, url, newFolderName) {
      var deferred = $q.defer();
      $http.post('/' + url, {
        folderid: baseFolderId.toString(),
        foldername: newFolderName
      }).then(function (result) {
        deferred.resolve(result.data);
      }, function () {
        deferred.reject();
      });
      return deferred.promise;
    };

    _formService.createSubFolder = function (folderName, baseFolderId, url, parentFolderId) {
      var deferred = $q.defer();
      $http.post('/' + url, {
        foldername: folderName,
        basefolderid: baseFolderId.toString(),
        parentfolderid: parentFolderId.toString()
      }).then(function (result) {
        deferred.resolve(result.data);
      }, function () {
        deferred.reject();
      });
      return deferred.promise;
    };

    _formService.deleteFile = function (url, contentId) {
      var deferred = $q.defer();
      $http.post('/' + url, {
        fileContentReferenceId: contentId.toString()
      }).then(function (result) {
        deferred.resolve(result);
      }, function () {
        deferred.reject();
      });
      return deferred.promise;
    };

    _formService.deleteFolder = function (url, contentId) {
      var deferred = $q.defer();
      $http.post('/' + url, {
        folderid: contentId.toString()
      }).then(function (result) {
        deferred.resolve(result);
      }, function () {
        deferred.reject();
      });
      return deferred.promise;
    };

    _formService.searchForMember = function (groupPage, searchString) {
      var deferred = $q.defer();
      $http.post('/MemberListBlock/SearchForUser', {
        groupPage: groupPage,
        searchString: searchString
      }).then(function (data, status, headers, config) {
        deferred.resolve(data.data);
      }, function () {
        deferred.reject();
      });
      return deferred.promise;
    };

    _formService.addUserToGroup = function (groupPage, groupName, userName) {
      var deferred = $q.defer();
      $http.post('/MemberListBlock/AddUserToGroup', {
        groupPage: groupPage,
        newMemberUserName: userName
      }).then(function (data, status, headers, config) {
        deferred.resolve(data.data);
      }, function () {
        deferred.reject();
      });
      return deferred.promise;
    };

    _formService.removeUserFromGroup = function (userName, groupName, groupPage) {
      var deferred = $q.defer();
      $http.post('/MemberListBlock/RemoveUserFromGroup', {
        groupPage: groupPage,
        groupName: groupName,
        userName: userName
      }).then(function (data, status, headers, config) {
        deferred.resolve(data.data);
      }, function () {
        deferred.reject();
      });
      return deferred.promise;
    };

    _formService.addLink = function (currentBlockTitle, groupPage, title, url) {
      var deferred = $q.defer();
      $http.post('/LinkListBlock/SaveLink', {
        currentBlockTitle: currentBlockTitle,
        groupPage: groupPage,
        title: title,
        url: url
      }).then(function (data, status, headers, config) {
        deferred.resolve(data.data);
      }, function () {
        deferred.reject();
      });
      return deferred.promise;
    };

    _formService.removeLink = function (currentBlockTitle, groupPage, linkId) {
      var deferred = $q.defer();
      $http.post('/LinkListBlock/RemoveLink', {
        currentBlockTitle: currentBlockTitle,
        groupPage: groupPage,
        groupLinkId: linkId
      }).then(function (data, status, headers, config) {
        deferred.resolve(data.data);
      }, function () {
        deferred.reject();
      });
      return deferred.promise;
    };

    _formService.addShoutout = function (groupPage, groupName, message) {
      var deferred = $q.defer();
      $http.post('/ShoutoutBlock/Save', {
        groupPageReference: groupPage,
        groupName: groupName,
        message: message
      }).then(function (data, status, headers, config) {
        deferred.resolve(data.data);
      }, function () {
        deferred.reject();
      });
      return deferred.promise;
    };

    _formService.handleMail = function (groupPage) {
      var deferred = $q.defer();
      $http.post('/ShoutoutBlock/HandleMail', {
        groupPageReference: groupPage
      }).then(function (data) {
        deferred.resolve(data.data);
      }, function () {
        deferred.reject();
      });
      return deferred.promise;
    };

    _formService.removeGroupEvent = function (groupPageReference, groupEventId) {
      var deferred = $q.defer();
      $http.post('/Shoutoutblock/Remove', {
        groupPageReference: groupPageReference,
        groupEventId: groupEventId
      }).then(function () {
        deferred.resolve();
      }, function () {
        deferred.reject();
      });
      return deferred.promise;
    };

    _formService.getAllMeetings = function (contentGuid) {
      var deferred = $q.defer();
      $http.get('/api/meetinggroupapi/' + contentGuid).then(function (data) {
        deferred.resolve(data);
      }, function () {
        deferred.reject();
      });
      return deferred.promise;
    };

    _formService.createMeeting = function (contentGuid, data) {
      var deferred = $q.defer();
      $http.post('/api/meetingapi/' + contentGuid, data).then(function (result) {
        deferred.resolve();
      }, function () {
        deferred.reject();
      });
      return deferred.promise;
    };

    _formService.getDetailsForMeeting = function (meetingContentGuid) {
      var deferred = $q.defer();
      $http.get('/api/meetingapi/' + meetingContentGuid).then(function (data) {
        deferred.resolve(data);
      }, function () {
        deferred.reject();
      });
      return deferred.promise;
    };

    _formService.saveMeetingDetails = function (meetingContentGuid, data) {
      var deferred = $q.defer();
      $http.put('/api/meetingapi/' + meetingContentGuid, data).then(function (result) {
        deferred.resolve(result);
      }, function () {
        deferred.reject();
      });
      return deferred.promise;
    };

    _formService.deleteMeeting = function (meetingContentGuid) {
      var deferred = $q.defer();
      $http.delete('/api/meetingapi/' + meetingContentGuid).then(function (result) {
        deferred.resolve(result);
      }, function () {
        deferred.reject();
      });
      return deferred.promise;
    };

    return _formService;
  }

  ;
})();